import { tns } from 'node_modules/tiny-slider/src/tiny-slider';

export class Product {
  constructor() {
    this.initCarousel();
  }

  /**
   * Initializes tiny-slider carousel and description components within carousel slide
   * Must be called after stream fetch + soy2js render
   */
  initCarousel() {
    const morningCarouselEl = document.querySelector('.js-morningCarousel');
    const afternoonCarouselEl = document.querySelector('.js-afternoonCarousel');
    const latenightCarouselEl = document.querySelector('.js-latenightCarousel');
    const breakfastCarouselEl = document.querySelector('.js-breakfastCarousel');
    
    const prevArrow = '<span class="Button ProductList-prevArrow"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M0.257485 7.37804L7.37841 0.257485C7.72172 -0.0858284 8.27865 -0.0858284 8.62196 0.257485L9.45258 1.08811C9.79553 1.43105 9.79589 1.98651 9.45405 2.33019L3.81044 7.99982L9.45368 13.6698C9.7959 14.0135 9.79516 14.5689 9.45222 14.9119L8.62159 15.7425C8.27828 16.0858 7.72136 16.0858 7.37804 15.7425L0.257485 8.62159C-0.0858285 8.27828 -0.0858285 7.72135 0.257485 7.37804Z" fill="currentColor"/></svg></>';
    const nextArrow = '<span class="Button ProductList-nextArrow" style="rotate:180deg;"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M0.257485 7.37804L7.37841 0.257485C7.72172 -0.0858284 8.27865 -0.0858284 8.62196 0.257485L9.45258 1.08811C9.79553 1.43105 9.79589 1.98651 9.45405 2.33019L3.81044 7.99982L9.45368 13.6698C9.7959 14.0135 9.79516 14.5689 9.45222 14.9119L8.62159 15.7425C8.27828 16.0858 7.72136 16.0858 7.37804 15.7425L0.257485 8.62159C-0.0858285 8.27828 -0.0858285 7.72135 0.257485 7.37804Z" fill="currentColor"/></svg></>';

    if (breakfastCarouselEl) {
      const slider = tns({
        container: '.js-breakfastCarousel',
        items: 1,
        slideBy: 1,
        nav: true,
        navPosition: 'bottom',
        controlsPosition: 'bottom',
        controlsText: [prevArrow, nextArrow],
        responsive: {
          768: {
            items: 3,
          },
        },
      });
    }

    if (morningCarouselEl) {
      const slider = tns({
        container: '.js-morningCarousel',
        items: 1,
        slideBy: 1,
        nav: true,
        navPosition: 'bottom',
        controlsPosition: 'bottom',
        controlsText: [prevArrow, nextArrow],
        responsive: {
          768: {
            items: 3,
          },
        },
      });
    }
    if (afternoonCarouselEl) {
      const slider = tns({
        container: '.js-afternoonCarousel',
        items: 1,
        slideBy: 1,
        nav: true,
        navPosition: 'bottom',
        controlsPosition: 'bottom',
        controlsText: [prevArrow, nextArrow],
        responsive: {
          768: {
            items: 3,
          },
        },
      });
    }
    if (latenightCarouselEl) {
      const slider = tns({
        container: '.js-latenightCarousel',
        items: 1,
        slideBy: 1,
        nav: true,
        navPosition: 'bottom',
        controlsPosition: 'bottom',
        controlsText: [prevArrow, nextArrow],
        responsive: {
          768: {
            items: 3,
          },
        },
      });
    }
  }
}